import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { clientQueryKeys } from "./query-keys";

import { instance } from "@/lib/axios/instance";
import { GetClientsResponse } from "@/types/response/GetClientsResponse";

const PAGE_SIZE = 20;

interface UseClientsInfiniteParams {
  tenantId?: string | null;
  search?: string;
}

export function useClientsInfinite({
  tenantId,
  search,
}: UseClientsInfiniteParams) {
  return useInfiniteQuery<GetClientsResponse, AxiosError>({
    queryKey: [...clientQueryKeys.all, "infinite", tenantId, search],
    enabled: true,
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      instance
        .get("/api/v2/Clients", {
          params: {
            tenantId: tenantId || undefined,
            search: search || undefined,
            page: pageParam,
            pageSize: PAGE_SIZE,
          },
        })
        .then((res) => res.data),
    getNextPageParam: (lastPage, allPages) => {
      const totalRecords = lastPage.totalRecords;
      const totalFetched = allPages.reduce(
        (acc, page) => acc + page.data.length,
        0
      );
      return totalFetched < totalRecords ? allPages.length + 1 : undefined;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    placeholderData: keepPreviousData,
  });
}
